/**
 * Created by BFR on 24/02/2020.
 */
define('editPimOptionView',[
  'module',
  'marionette',
  'app',
  'jquery',
  'underscore',
  'bootbox',
  'template!editPimOptionTpl',
  'pimUtil',
  'colorUtils',
  'dynamicTextView',
  'pimPicturePlaced'
], function (
  module,
  Marionette,
  App,
  $,
  _,
  bootbox,
  viewTpl,
  PimUtil,
  ColorUtils,
  DynamicTextView,
  Placed
) {
  'use strict';

  var EditPimOptionView = Marionette.LayoutView.extend({
    template: viewTpl,
    className: 'option',

    attributes: function () {
      return {'data-pimid': this.model.get('pimId')};
    },

    regions: {
      nameRegion: '.opt-name-region'
    },

    events: {
      'change .cbx-enable-opt': 'onCbxEnableOptChange',
      'change .js-upload-opt-image': 'onAddImages',
      // Triggered on a picture by the context menu of the overview tab
      'pim:option-image:replace .js-image-cell': 'onReplaceImage',
      'pim:option-image:delete .js-image-cell': 'onDeleteImage'
    },

    // Re-run after each render: an upload or a deletion redraws the option
    onRender: function () {
      if (this.model.get('name').get('glossaryDt')) {
        this.nameDtView = new DynamicTextView({
          model: this.model.get('name').get('glossaryDt'),
          hideGlossary: true,
          showWebIcon: true
        });
        this.getRegion('nameRegion').show(this.nameDtView);
      }

      _.each(this.$el.find('.image'), _.bind(function (image) {
        var content = '<div class="img-responsive"><img class="img-popover" src="' + $(image).find('img').attr('src') + '"/></div>';

        var target = $(image).find('img');

        target.attr('data-content', content);
        target.popover({
          trigger: 'hover',
          placement: 'left',
          html: 'true',
          container: $('#content')
        }).data('bs.popover').tip().addClass('jqgrid-popover');
      }, this));
    },

    onDestroy: function () {
      $('.jqgrid-popover').remove();
    },

    serializeData: function () {
      var templateData = {};

      templateData.code = this.model.get('code');

      // On/Off true by default, unless specified otherwise in resellerData.
      templateData.activated = true;
      try {
        var currentModel = this.options.model;
        // If reseller data has an overridden value, use that.
        if (this.options.pimProduct && this.options.pimProduct.get('resellerData')) {
          _.each(this.options.pimProduct.get('resellerData').models, _.bind(
                  function (rd) {
                    if (rd && rd.get('pimPoResellers')) {
                      _.each(rd.get('pimPoResellers').models, _.bind(
                          function (poc) {
                            if (poc && poc.get('productOptions')) {
                              _.each(poc.get('productOptions').models, _.bind(
                                  function (po) {
                                    // Apply the activated value from the reseller data if the pimId is matching
                                    if (po && po.get('pimId') === currentModel.get('pimId')) {
                                      if (po.get('activated') !== undefined) {
                                        // Provide the template
                                        templateData.activated = po.get('activated');

                                        // Update the model with the activated value in order to save it to the backend, if sent
                                        _.each(currentModel.collection.models, _.bind(function (oc) {
                                          // Find the matching model by pimId
                                          if(currentModel.get('pimId') === oc.get('pimId')) {
                                            oc.set('activated', po.get('activated'));
                                          }
                                        }, this));

                                      }
                                    }
                                  }
                              ));
                            }
                          }
                      ));
                    }
                  }
              )
          );
        }
      } catch (e) {
          console.log('Error in EditPimOptionView. Could not apply any override from pimPoResellers', e);
      }
      var aNames = this.model.get('name').get('values');

      templateData.name = PimUtil.getTranslation(aNames);

      // This option comes from EditPimOptionsView
      templateData.enableOnOff = this.options.enableOnOff;

      templateData.color = '';

      var color1 = this.model.get('color1');

      if (color1) {
        templateData.color = ColorUtils.decimalToHexa(color1['int']);
      }

      // The supplier's pictures, each with its view (1-4 = picture1..4, then addImages.index)
      var views = [];
      _.each([1, 2, 3, 4], _.bind(function (i) {
        if (this.model.get('picture' + i)) {
          views.push({index: i, url: this.model.get('picture' + i)});
        }
      }, this));
      _.each(this.model.get('addImages'), function (image) {
        views.push({index: image.index, url: image.url});
      });

      // Products from the supplier portal carry pictures one to four under
      // picture1..4 and under addImages both; one thumbnail each is enough.
      views = _.uniq(_.filter(views, function (v) {
        return !!v.url;
      }), false, function (v) {
        return v.url;
      });

      templateData.allowUpload = false;

      var currentResProduct = this.options.pimProduct ? this.options.pimProduct.getCurrentResProduct() : null;

      // The reseller's own images: in place of the supplier's for the same view, after them otherwise
      _.each(this.getOwnImages(), function (own) {
        var view = _.findWhere(views, {index: own.index}),
          entry = {index: own.index, url: own.url, uid: own.uid, fileName: own.fileName};
        if (view) {
          views[_.indexOf(views, view)] = _.extend(entry, {replaces: view.url});
        } else {
          views.push(entry);
        }
      });

      templateData.images = views;

      // A badge on each picture that has print areas placed on it, so nobody
      // has to open the positioner to find out. Picture n here is picture n
      // there: the same list, in the same order.
      var saved = currentResProduct ? (currentResProduct.get('pimPicturePositions') || []) : [];
      var addImages = this.model.get('addImages') || [];
      templateData.placed = _.map(views, _.bind(function (view, i) {
        var supplier = _.findWhere(addImages, {url: view.url});
        var placed = Placed.onPicture(saved, this.model.get('pimId'), i + 1, view.url,
          supplier ? supplier.productPicturePositions : null);
        return placed ? _.extend({title: Placed.title(placed)}, placed) : null;
      }, this));
      templateData.pimId = this.model.get('pimId');

      if (currentResProduct) {
        templateData.allowUpload = true;
        templateData.defaultIndexPicture = currentResProduct.get('defaultIndexPicture');
      } else {
        templateData.defaultIndexPicture = null;
      }

      return templateData;
    },

    getResProduct: function () {
      return this.options.pimProduct ? this.options.pimProduct.getCurrentResProduct() : null;
    },

    /**
     * The reseller's images of this option (stored on the reseller product as
     * `optionImages`, filtered by the option pimId).
     */
    getOwnImages: function () {
      var resProduct = this.getResProduct(),
        pimId = this.model.get('pimId');
      if (!resProduct) {
        return [];
      }
      return _.sortBy(_.filter(resProduct.get('optionImages') || [], function (image) {
        return image.optionPimId === pimId;
      }), 'index');
    },

    /**
     * Replace this option's images in the reseller product with the list returned by the server.
     */
    setOwnImages: function (images) {
      var resProduct = this.getResProduct(),
        pimId = this.model.get('pimId');
      if (!resProduct) {
        return;
      }
      var others = _.filter(resProduct.get('optionImages') || [], function (image) {
        return image.optionPimId !== pimId;
      });
      resProduct.set('optionImages', others.concat(images || []));
      this.render();
    },

    uploadImages: function (files, index) {
      var resProduct = this.getResProduct();
      if (!resProduct || !files || !files.length) {
        return;
      }
      var formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
      if (index) {
        formData.append('index', index);
      }
      this.$el.find('.opt-image-upload').addClass('uploading');

      $.when(App.request('pim:products:upload-option-images', resProduct.get('id'), this.model.get('pimId'), formData))
        .done(_.bind(this.setOwnImages, this))
        .fail(_.bind(function (xhr) {
          this.$el.find('.opt-image-upload').removeClass('uploading');
          bootbox.alert(xhr && xhr.responseText ? xhr.responseText : 'Error uploading image');
        }, this));
    },

    onAddImages: function (e) {
      this.uploadImages(e.target.files);
    },

    onReplaceImage: function (e) {
      var index = $(e.currentTarget).data('view'),
        input = $('<input type="file" accept="image/png,image/jpeg,image/gif,image/webp"/>');
      input.on('change', _.bind(function () {
        this.uploadImages(input[0].files, index);
      }, this));
      input.trigger('click');
    },

    onDeleteImage: function (e) {
      var resProduct = this.getResProduct(),
        uid = $(e.currentTarget).data('uid');
      if (!resProduct || !uid) {
        return;
      }
      bootbox.confirm(_.i18n('common.confirmDelete'), _.bind(function (result) {
        if (!result) {
          return;
        }
        $.when(App.request('pim:products:delete-option-image', resProduct.get('id'), this.model.get('pimId'), uid))
          .done(_.bind(this.setOwnImages, this))
          .fail(function () {
            bootbox.alert('Error deleting image');
          });
      }, this));
    },

    onCbxEnableOptChange: function (event) {
      var cbx = $(event.target), currentOc;
      _.each(this.options.model.collection.models, _.bind(function (oc) {
        // Find the matching model by pimId
        if(this.options.model.get('pimId') === oc.get('pimId')) {
          currentOc = oc;
        }
      }, this));

      if(currentOc){
        if (cbx.is(':checked')) {
          currentOc.set('activated', true);
        } else {
          currentOc.set('activated', false);
        }
      }
    }
  });

  module.exports = EditPimOptionView;
});
